import { useCampaignListQuery } from 'gql'
import { useEffect } from 'react'
import { Link } from 'react-router'
import { Grid, Header, Image } from 'semantic-ui-react'
import { CampaignCard, PaginationButton, Routes, t, usePaginatedQuery } from 'shared'
import CardList from './campaign_card'
import ZeroResultImage from './kampagnenkacheln-zero-case.svg'
import { CampaignListProps } from './types'
import { SearchRankingModal } from 'application/campaign/search_ranking_modal'
import './campaign_list_styles.sass'

const CampaignList = ({ handleLoaded, queryVariables = {}, showZeroResultHint }: CampaignListProps) => {
  const { data, edges, loading, pagination } = usePaginatedQuery(
    useCampaignListQuery,
    { variables: queryVariables },
    (element) => element.search.campaigns
  )

  useEffect(() => {
    handleLoaded && data && handleLoaded(data.search.totalCount)
  }, [data, handleLoaded])

  if (showZeroResultHint && !edges?.length && !loading)
    return (
      <Grid centered>
        <Grid.Column className="mt-medium" mobile={12} tablet={12} computer={4} style={{ textAlign: 'center' }}>
          <Image src={ZeroResultImage} alt="Zero Results" centered className="mb-big" />
          <h2 className="ui header centered">{t('search.no_results_header')}</h2>
          <p>
            {t('search.no_results_message_part_1')}{' '}
            <Link to={Routes.newCampaignPath('campaign')}>{t('search.no_results_message_part_2_cta')}</Link>.
          </p>
        </Grid.Column>
      </Grid>
    )

  return (
    <>
      {showZeroResultHint && data && (
        <>
          <Header as="h1" textAlign="center">
            {t('campaign.search_results')}
          </Header>
          <div style={{ textAlign: 'center' }}>
            {data.search.totalCount} {t('campaign.campaign_found_for', { count: data.search.totalCount })}:{' '}
            <i>{queryVariables.q}</i>
          </div>
          <div className="search-ranking-container">
            <SearchRankingModal />
          </div>
        </>
      )}
      <CampaignCard.Group>
        <CardList edges={edges} loading={loading} />
        <PaginationButton
          pagination={pagination}
          primary
          content={t('verbs.show_more')}
          className="mt-small"
          style={{ marginLeft: 'auto', marginRight: 'auto' }}
        />
      </CampaignCard.Group>
      <div className="mb-small">&nbsp;</div>
    </>
  )
}

export default CampaignList
